export const ACTION_RESET = 'FETCH_PRESSDATABYID_RESET';
export const ACTION_REQUEST = 'FETCH_PRESSDATABYID_REQUEST';
export const ACTION_SUCCESS = 'FETCH_PRESSDATABYID_SUCCESS';
export const ACTION_ERROR = 'FETCH_PRESSDATABYID_ERROR';
